// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Avatar_avatarContainer__t6lV5","avatar-img":"Avatar_avatar-img__8BPeY","spinner":"Avatar_spinner__YxYLs"};